import { gql } from '@apollo/client';
/**
 * @const SendTaskListApprovalEmailMutation
 * @since 1.0.0
 */
export const SendTaskListApprovalEmailMutation = gql `
  mutation SendTaskListApprovalEmailMutation(
    $input: SendTaskListApprovalEmailInput!
  ) {
    sendTaskListApprovalEmail(input: $input)
  }
`;
